
import { SuserModel } from '../../Models/suser-model';


export class SuserMocks {

  private static models: SuserModel[];
  private static  idCounter = 0;

  public static initMocks(){
    SuserMocks.models = [];
    SuserMocks.models.push({uId: ++this.idCounter, id: "jdbbvbdeyuev", name: "User"});
    SuserMocks.models.push({uId: ++this.idCounter, id: "ffffeygfeyugfy", name: "Admin"});
  }

  public static findByObjectId(id: string):SuserModel{
    let m = SuserMocks.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].id) return m[i];
    }
    return null;
  }

  public static findById(id:number):SuserModel{
    let m = SuserMocks.models;
    for(let i = 0; i< m.length; i++){
      if(id == m[i].uId) return m[i];
    }
    return null;
  }

  public static getItems():SuserModel[]{
    return SuserMocks.models;
  }

}
